import React from "react";
import { styled } from "styled-components";
import { Avatar as MUIAvatar } from "@mui/material";

interface Props {
  src: string;
  height: string | number;
  width: string | number;
  variant: "circle" | "circular" | "rounded" | "square";
  alt: string;
  style?: React.CSSProperties;
}

// Move StyledAvatar outside the component to avoid dynamic styled-component warning
const StyledAvatar = styled(MUIAvatar)<{
  width: string | number;
  height: string | number;
}>(({ width, height }) => ({
  width,
  height,
}));

const Avatar: React.FC<Props> = ({
  height,
  width,
  src,
  alt,
  variant,
  style,
}: Props) => {
  return (
    <StyledAvatar
      src={src}
      alt={alt}
      style={style}
      width={width}
      height={height}
    />
  );
};

export default Avatar;
